import React, { useEffect } from 'react' 
import { useDispatch, useSelector } from 'react-redux'
import { getVideos } from 'features/videos/videoSlice'
import VideoCard from './VideoCard'
import { NoItemsContainer } from 'components/main.styled'
import { HiVideoCameraSlash } from "react-icons/hi2";

import { MediaFeedContainer } from '../media.styled'
import { useTranslation } from 'react-i18next'

export default function VideoFeed() {
  const { t } = useTranslation('media')

    const dispatch = useDispatch()
    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { videos, videoSort, getVideosSuccess, getVideosLoading } = useSelector((state) => state.video)
    const { user } = useSelector((state) => state.auth)

    useEffect(() => {
        dispatch(getVideos({
            churchId: profileChurch._id,
            sort: videoSort
        }))
    }, [videoSort])

    return (
        <MediaFeedContainer> 
            {   getVideosSuccess ?
                (
                    videos.length > 0 ?
                    (
                        videos.map((video) => (
                            <VideoCard key={video._id} data={video} />
                        ))
                    )
                    :
                    (
                        <NoItemsContainer>
                            <HiVideoCameraSlash />
                            <div>
                                {
                                    t('noVideos')
                                }
                            </div>
                        </NoItemsContainer>
                    )
                )
                :
                (
                    <NoItemsContainer>
                        <HiVideoCameraSlash />
                        <p>{t('noVideos')}</p>
                    </NoItemsContainer>
                )

            }

        </MediaFeedContainer>
    )
}

